// TODO: The public platform ids listed in here are supporting hacks to provide one-off
// customization that should be replaced as soon as possible with generic solutions.
export default {
    square: new Set([
        // Staging
        'f03ca7ac-bae7-4d38-853e-d22bf55395c3',
        // Production
        '484d5b00-8c3b-4ce9-9270-a5537bdaec3a',
    ]),
};
export var AMAZON_FLEX = 'eec356b5-9338-4c7c-ac95-b5fdb2213633';
export var AMAZON = '680d0bc6-906c-47ba-9c81-4409039ab556';
export var AMAZON_STAGING = '877275da-0ae9-4e4d-8ef3-d2495f94ec65';
export var ADP = '5becff90-1e35-450a-8995-13ac411e749b';
var ADP_STAGING = 'bcd9d730-2d9c-4479-8826-b7fcec7d49c8';
export var ADP_PARTNERSHIP_ID = {
    STAGING: '737fc0b3-400c-456a-b14f-dccf0b22216a',
    PRODUCTION: '7c67d393-9c4d-4427-bdca-4fe39a708218',
};
export var isAdp = function (uuid) { return uuid === ADP || uuid === ADP_STAGING; };
export var isAdpPartnership = function (uuid) {
    return uuid === ADP_PARTNERSHIP_ID.STAGING || uuid === ADP_PARTNERSHIP_ID.PRODUCTION;
};
export var isAmazon = function (uuid) {
    return uuid === AMAZON || uuid === AMAZON_STAGING;
};
